exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accessory-card .multiselect {\n  width: 25%;\n}\n.accessory-card .multiselect__option--highlight {\n  background: #51007a;\n  outline: none;\n  color: #fff;\n}\n.accessory-card .multiselect__option--selected.multiselect__option--highlight {\n  background: #f3f3f3;\n  color: #35495e;\n  cursor: default;\n}", ""]);

// exports
